import React, { Component } from 'react';
import { connect } from 'react-redux';
import { createCollection } from 'actions/collections';
import { setPopUp } from 'actions/environment';
import cn from 'classnames';
import styles from './Collections.scss';
import CollectionsDialog from '../CollectionsDialog';
import { withTranslation } from 'react-i18next';

class Collections extends Component {

  handleClick = () => {
    const { onClick } = this.props;

    if (onClick) {
      onClick();
    }

    this.props.setPopUp(
      <CollectionsDialog building={this.props.building} />,
      {
        closeStyleName: 'Default',
        contentStyleName: 'Default',
        closeIcon: 'default',
        lockScroll: false
      }
    );
  }

  render() {
    const { className, t } = this.props;
    return (
      <div className={cn(styles.Collections, className)}>
        <button
          className={styles.ButtonAddToCollection}
          onClick={this.handleClick}
          data-tip={t('components.building.main.collections.add')}
          data-for="global"
        >
          <span><i></i><i></i></span>
        </button>
      </div>
    );
  }
}

export default withTranslation()(connect(
  state => state.profile,
  {
    createCollection,
    setPopUp
  }
)(Collections));



// WEBPACK FOOTER //
// ./src/components/Building/Main/Collections/Collections.js